export const MFA_RESEND_CODE_LINK_TEXT = 'Resend Code';

export const MFA_SUBMIT_BUTTON_TEXT = 'Submit';

export const SET_PROFILE_CONTINUE_BUTTON_TEXT = 'Continue';
